export enum URLs {
    PROGRAM_MAKER = '/program-maker',
    BOTS = '/bots',
    BOT = '/bots/:botID',
    BINANCE_ACCOUNTS = '/binance-accounts',
    TRADING_PROGRAMS = '/trading-programs',
    SIMULATE = '/simulate',
}
